import {Link} from "react-router-dom"

const UserBox = ({post}) => {
    const user = post.user
    const userExist = user != null
    const imageSource = (userExist && user.image != null) ? user.image : "/icons/user.png"
    const link = !userExist ? `${post.id}/create` : `${post.id}/show`
    return <Link to={link}
                 className="w-[80%] md:w-[22%] md:mt-5 text-center p-3 pr-[15%] md:pr-[2%] mx-auto flex items-center shadow mt-3 bg-gray2 text-white font-bold">
        <img src={imageSource} className="me-3 w-[35px] h-[35px]"/>
        <div  className="flex flex-col justify-around items-start">
            {userExist ?
                <>
                    <span className="text-[12px] text-orange">{user.name + ' ' + user.lastname}</span>
                    <span className="text-[15px]">{post.name}</span>
                </> :
                <span className="text-[18px]">{post.name}</span>
            }
        </div>
    </Link>
}

export default UserBox